import { Instance, types } from 'mobx-state-tree';

export const QuizListElementModel = types
  .model({
    id: types.number,
    name: types.string,
    quizType: types.string,
    isActive: types.boolean,
    startDate: types.string,
    endDate: types.string,
    createdAt: types.string,
  })
  .named('QuizListElementModel');

export type QuizListElementModelType = Instance<typeof QuizListElementModel>;
